<div class="flex flex-column gap-4" [formGroup]="form">
    <p-accordion [multiple]="true" [activeIndex]="[0,1,2,3,4,5,6]" expandIcon="pi pi-chevron-down"
        collapseIcon="pi pi-chevron-up">

        <p-accordionTab header="Application Information">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Application Fees</label>
                    <input pInputText type="text" class="w-full" placeholder="$ e.g. 75"
                        formControlName="applicationFees" />
                    <div *ngIf="form.get('applicationFees')?.touched && form.get('applicationFees')?.invalid">
                        <small *ngIf="form.get('applicationFees')?.hasError('required')"
                            class="p-error block mt-1">Application Fees is required.</small>
                        <small *ngIf="form.get('applicationFees')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Currency</label>
                    <p-dropdown [options]="currency" optionLabel="label" optionValue="value"
                        placeholder="Select Currency" styleClass="w-full" [showClear]="true"
                        formControlName="currency"></p-dropdown>
                    <div *ngIf="form.get('currency')?.touched && form.get('currency')?.invalid">
                        <small *ngIf="form.get('currency')?.hasError('required')" class="p-error block mt-1">Currency is
                            required.</small>
                    </div>
                </div>
                <div class="field col-12">
                    <label class="font-medium text-900">English Language Requirement</label>
                    <textarea pInputTextarea rows="2" class="w-full"
                        placeholder="Detail English proficiency requirements (TOEFL, IELTS, etc.)"
                        formControlName="englishLanguageRequirement"></textarea>
                    <div
                        *ngIf="form.get('englishLanguageRequirement')?.touched && form.get('englishLanguageRequirement')?.invalid">
                        <small *ngIf="form.get('englishLanguageRequirement')?.hasError('pattern')"
                            class="p-error block mt-1">Must be alphabetic.</small>
                    </div>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Financial Information">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Tuition Fees</label>
                    <input pInputText type="text" class="w-full" placeholder="$ Tuition amount"
                        formControlName="tuitionFees" />
                    <div *ngIf="form.get('tuitionFees')?.touched && form.get('tuitionFees')?.invalid">
                        <small *ngIf="form.get('tuitionFees')?.hasError('pattern')" class="p-error block mt-1">Must be a
                            number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Housing Capacity</label>
                    <input pInputText type="text" class="w-full" placeholder="Housing units"
                        formControlName="housingCapacity" />
                    <div *ngIf="form.get('housingCapacity')?.touched && form.get('housingCapacity')?.invalid">
                        <small *ngIf="form.get('housingCapacity')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Combined Food & Housing Charge</label>
                    <input pInputText type="text" class="w-full" placeholder="$ Combined cost"
                        formControlName="combinedFoodHousingCharge" />
                    <div
                        *ngIf="form.get('combinedFoodHousingCharge')?.touched && form.get('combinedFoodHousingCharge')?.invalid">
                        <small *ngIf="form.get('combinedFoodHousingCharge')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Median Family Income</label>
                    <input pInputText type="text" class="w-full" placeholder="Median Income"
                        formControlName="medianFamilyIncome" />
                    <div *ngIf="form.get('medianFamilyIncome')?.touched && form.get('medianFamilyIncome')?.invalid">
                        <small *ngIf="form.get('medianFamilyIncome')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Enrollment Statistics">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Graduate Students Enrolled</label>
                    <input pInputText type="text" class="w-full" placeholder="Enrolled count"
                        formControlName="graduateStudentsEnrolled" />
                    <div
                        *ngIf="form.get('graduateStudentsEnrolled')?.touched && form.get('graduateStudentsEnrolled')?.invalid">
                        <small *ngIf="form.get('graduateStudentsEnrolled')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Part-Time Enrollment</label>
                    <input pInputText type="text" class="w-full" placeholder="Part-time count"
                        formControlName="partTimeEnrollment" />
                    <div *ngIf="form.get('partTimeEnrollment')?.touched && form.get('partTimeEnrollment')?.invalid">
                        <small *ngIf="form.get('partTimeEnrollment')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">International Graduate Students</label>
                    <input pInputText type="text" class="w-full" placeholder="International count"
                        formControlName="internationalGraduateStudents" />
                    <div
                        *ngIf="form.get('internationalGraduateStudents')?.touched && form.get('internationalGraduateStudents')?.invalid">
                        <small *ngIf="form.get('internationalGraduateStudents')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Full Time Indian Post-Graduate Students</label>
                    <input pInputText type="text" class="w-full" placeholder="Count"
                        formControlName="fullTimeIndianPostGraduateStudents" />
                    <div
                        *ngIf="form.get('fullTimeIndianPostGraduateStudents')?.touched && form.get('fullTimeIndianPostGraduateStudents')?.invalid">
                        <small *ngIf="form.get('fullTimeIndianPostGraduateStudents')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Male Graduate Enrollment</label>
                    <input pInputText type="text" class="w-full" placeholder="Count"
                        formControlName="maleGraduateEnrollment" />
                    <div
                        *ngIf="form.get('maleGraduateEnrollment')?.touched && form.get('maleGraduateEnrollment')?.invalid">
                        <small *ngIf="form.get('maleGraduateEnrollment')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Female Graduate Enrollment</label>
                    <input pInputText type="text" class="w-full" placeholder="Count"
                        formControlName="femaleGraduateEnrollment" />
                    <div
                        *ngIf="form.get('femaleGraduateEnrollment')?.touched && form.get('femaleGraduateEnrollment')?.invalid">
                        <small *ngIf="form.get('femaleGraduateEnrollment')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Demographics (%)">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Male Percentage</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100" formControlName="malePercentage" />
                    <div *ngIf="form.get('malePercentage')?.touched && form.get('malePercentage')?.invalid">
                        <small *ngIf="form.get('malePercentage')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Female Percentage</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100"
                        formControlName="femalePercentage" />
                    <div *ngIf="form.get('femalePercentage')?.touched && form.get('femalePercentage')?.invalid">
                        <small *ngIf="form.get('femalePercentage')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">American Indian / Alaska Native (%)</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100"
                        formControlName="americanIndianPercentage" />
                    <div
                        *ngIf="form.get('americanIndianPercentage')?.touched && form.get('americanIndianPercentage')?.invalid">
                        <small *ngIf="form.get('americanIndianPercentage')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Asian (%)</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100"
                        formControlName="asianPercentage" />
                    <div *ngIf="form.get('asianPercentage')?.touched && form.get('asianPercentage')?.invalid">
                        <small *ngIf="form.get('asianPercentage')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Black / African American (%)</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100"
                        formControlName="blackPercentage" />
                    <div *ngIf="form.get('blackPercentage')?.touched && form.get('blackPercentage')?.invalid">
                        <small *ngIf="form.get('blackPercentage')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Hispanic / Latino (%)</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100"
                        formControlName="hispanicPercentage" />
                    <div *ngIf="form.get('hispanicPercentage')?.touched && form.get('hispanicPercentage')?.invalid">
                        <small *ngIf="form.get('hispanicPercentage')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Native Hawaiian / Other Pacific Islander (%)</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100"
                        formControlName="nativeHawaiianPercentage" />
                    <div
                        *ngIf="form.get('nativeHawaiianPercentage')?.touched && form.get('nativeHawaiianPercentage')?.invalid">
                        <small *ngIf="form.get('nativeHawaiianPercentage')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">White (%)</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100"
                        formControlName="whitePercentage" />
                    <div *ngIf="form.get('whitePercentage')?.touched && form.get('whitePercentage')?.invalid">
                        <small *ngIf="form.get('whitePercentage')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Two Or More Races (%)</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100"
                        formControlName="twoOrMoreRacesPercentage" />
                    <div
                        *ngIf="form.get('twoOrMoreRacesPercentage')?.touched && form.get('twoOrMoreRacesPercentage')?.invalid">
                        <small *ngIf="form.get('twoOrMoreRacesPercentage')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Race Unknown (%)</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100"
                        formControlName="raceUnknownPercentage" />
                    <div
                        *ngIf="form.get('raceUnknownPercentage')?.touched && form.get('raceUnknownPercentage')?.invalid">
                        <small *ngIf="form.get('raceUnknownPercentage')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a valid percentage.</small>
                    </div>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Graduate Assistantships">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Graduate Assistant Total</label>
                    <input pInputText type="text" class="w-full" placeholder="Total assistantships"
                        formControlName="graduateAssistantTotal" />
                    <div
                        *ngIf="form.get('graduateAssistantTotal')?.touched && form.get('graduateAssistantTotal')?.invalid">
                        <small *ngIf="form.get('graduateAssistantTotal')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Teaching Assistants</label>
                    <input pInputText type="text" class="w-full" placeholder="TA count"
                        formControlName="teachingAssistants" />
                    <div *ngIf="form.get('teachingAssistants')?.touched && form.get('teachingAssistants')?.invalid">
                        <small *ngIf="form.get('teachingAssistants')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Research Assistants</label>
                    <input pInputText type="text" class="w-full" placeholder="RA count"
                        formControlName="researchAssistants" />
                    <div *ngIf="form.get('researchAssistants')?.touched && form.get('researchAssistants')?.invalid">
                        <small *ngIf="form.get('researchAssistants')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Academic">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">PhD Programs</label>
                    <input pInputText type="text" class="w-full" placeholder="PhD program count"
                        formControlName="phdPrograms" />
                    <div *ngIf="form.get('phdPrograms')?.touched && form.get('phdPrograms')?.invalid">
                        <small *ngIf="form.get('phdPrograms')?.hasError('pattern')" class="p-error block mt-1">Must be a
                            number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Masters Programs</label>
                    <input pInputText type="text" class="w-full" placeholder="Masters program count"
                        formControlName="MastersPrograms" />
                    <div *ngIf="form.get('MastersPrograms')?.touched && form.get('MastersPrograms')?.invalid">
                        <small *ngIf="form.get('MastersPrograms')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Faculty</label>
                    <input pInputText type="text" class="w-full" placeholder="Count" formControlName="faculty" />
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Total Departments</label>
                    <input pInputText type="text" class="w-full" placeholder="Count"
                        formControlName="totalDepartments" />
                    <div *ngIf="form.get('totalDepartments')?.touched && form.get('totalDepartments')?.invalid">
                        <small *ngIf="form.get('totalDepartments')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Total Enrollment</label>
                    <input pInputText type="text" class="w-full" placeholder="Total enrolled count"
                        formControlName="totalEnrollment" />
                    <div *ngIf="form.get('totalEnrollment')?.touched && form.get('totalEnrollment')?.invalid">
                        <small *ngIf="form.get('totalEnrollment')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12">
                    <label class="font-medium text-900">Scholarships</label>
                    <textarea pInputTextarea rows="4" class="w-full"
                        placeholder="Enter one scholarship per line"
                        formControlName="scholarships"></textarea>
                    <small class="text-500 block mt-1">Enter one scholarship name per line.</small>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Other Information">
            <div class="grid">
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">UK Institute</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., 10%" formControlName="uk" />
                    <div *ngIf="form.get('uk')?.touched && form.get('uk')?.invalid">
                        <small *ngIf="form.get('uk')?.hasError('pattern')" class="p-error block mt-1">
                            Must be a valid percentage.
                        </small>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">EU Institute</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., 10%" formControlName="eu" />
                    <div *ngIf="form.get('eu')?.touched && form.get('eu')?.invalid">
                        <small *ngIf="form.get('eu')?.hasError('pattern')" class="p-error block mt-1">
                            Must be a valid percentage.
                        </small>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">Post Graduate Offerings</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., 10%"
                        formControlName="postGraduate" />
                    <div *ngIf="form.get('postGraduate')?.touched && form.get('postGraduate')?.invalid">
                        <small *ngIf="form.get('postGraduate')?.hasError('pattern')" class="p-error block mt-1">
                            Must be a valid percentage.
                        </small>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">Under Graduate Offerings</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., 10%"
                        formControlName="underGraduate" />
                    <div *ngIf="form.get('underGraduate')?.touched && form.get('underGraduate')?.invalid">
                        <small *ngIf="form.get('underGraduate')?.hasError('pattern')" class="p-error block mt-1">
                            Must be a valid percentage.
                        </small>
                    </div>
                </div>
            </div>
            <div class="field">
                <label class="font-medium text-900">Additional Notes</label>
                <textarea pInputTextarea rows="2" class="w-full" placeholder="Any additional information"
                    formControlName="additionalNotes"></textarea>
            </div>
        </p-accordionTab>
    </p-accordion>

</div>